import { render, staticRenderFns } from "./ManageFinalVideo.vue?vue&type=template&id=7145ff8d&scoped=true"
import script from "./ManageFinalVideo.vue?vue&type=script&lang=js"
export * from "./ManageFinalVideo.vue?vue&type=script&lang=js"
import style0 from "./ManageFinalVideo.vue?vue&type=style&index=0&id=7145ff8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145ff8d",
  null
  
)

export default component.exports